import { useEffect, useCallback, useMemo, useState, useRef, useContext } from "react";
import { createRoot } from 'react-dom/client';
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "./customStyles.css";
import { ModuleRegistry } from '@ag-grid-community/core';
import { DDD, E2Data } from "../../lib/ddd/ddd";
import classes from "./CustomersGrid.module.scss";
import { useTranslation } from 'react-i18next';
import { OrgIdContext } from "../../store/orgId_context";
import useEffectIgnoreFirst from "../../hooks/useEffectIgnoreFirst";


ModuleRegistry.registerModules([InfiniteRowModelModule]);

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("EU_Invoices_REI");


const BillingHistory = ({...props}) => {
    const table =useRef();
    const [requestParams, setRequestParams] = useState();
    const {sessionInfo, mainOrgId} = useContext(OrgIdContext)
    const [search, setSearch] = useState();
    const { t } = useTranslation();

    const [columnDefs, setColumnDefs] = useState([
        {
            field : "InvNum",
            headerName : t("Inovice number"),
            //sortable : false,
            //maxWidth:100,
            flex:1,
            cellStyle : {
                textAlign :"center"
            }
        },
        {
            field : "DateTimeCreate",
            headerName : t("Date Time Create"),
            flex:1,
        },
        {
            field : "InvPayableAmount",
            headerName : t("Total"),
            type: 'currency',
            flex: 3,
            minWidth:350
        },
        /* {
            field : "PaymentType",
            headerName : t("PaymentType")
        },
        {
            field : "PayType",
            headerName : t("PayType")
        },
        {
            field : "PackagePrice",
            headerName : t("PackagePrice"),
            type: 'currency',
            maxWidth:150,
            cellRenderer : (params) => {return params.value||0},
        }, */
        {
            field : "PDFPrimary",
            headerName : t("PDF"),
            //type: 'currency',
            maxWidth:150,
            cellRenderer : (params) => {return params.value||0},
        }
    ]);

    const onGridReady = useCallback((params) => {
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                setRequestParams(reqParams);
                loadEntityData(reqParams).then((res) =>{
                    console.log(res);
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                });
            }
        }
        params.api.setGridOption('datasource', dataSource);
    });

    const loadEntityData = ({startRow,endRow, search, sortModel}) => {
        e2Data.skip = startRow;
        e2Data.take = endRow-startRow;
        e2Data.filter = `SellerTaxNum  = "49263700"`;
        if(getFilterFromSearch(search))
            e2Data.filter += " AND (" + getFilterFromSearch(search)+")";
        e2Data.orderBy = getOrderByFromArray(sortModel);
        e2Data.includeCount = true;
        e2Data.format = "Full";
        return e2Data.GetData();
    }

    const getOrderByFromArray = (arr) => {
        if(!arr?.length) return null;

        let order = "";
        arr.forEach(item => order+= item.colId + " " + item.sort+", ");
        order = order.replace(/, +$/, "");
        return order;
    }
    const getFilterFromSearch = (globalSearch) =>{
        if(!globalSearch || globalSearch.trim() ==="") return null;

        return `Organisation contains "${globalSearch}" OR ConnectionKey contains "${globalSearch}" OR eMail contains "${globalSearch}"`;
    }

    useEffectIgnoreFirst(() =>{
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                reqParams.search = search;
                setRequestParams(reqParams);
                loadEntityData(reqParams).then((res) =>{
                    console.log(res);
                    reqParams.successCallback(res?.result?.Result, res?.result?.Count);
                });
            }
        }
        table?.current?.api?.setGridOption('datasource', dataSource);
        //table?.current?.api?.refreshServerSide({ route: undefined, purge: true });
    }, [search]);

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 200,
            sortable: true,
        }
    }, []);


    return (
        <div style={{ height: '100%', width: '100%' }} className={"ag-theme-quartz"}>
            <AgGridReact
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowBuffer={0}
                rowSelection={'multiple'}
                rowModelType={'infinite'}
                cacheBlockSize={100}
                cacheOverflowSize={2}
                maxConcurrentDatasourceRequests={1}
                infiniteInitialRowCount={1000}
                maxBlocksInCache={10}
                onGridReady={onGridReady}
                ref = {table}
            />
        </div>
        );
};

export default BillingHistory;
